export default __webpack_public_path__ + "static/location-head-map-light-efa0c177a425da97a16d5d81365b6ddd.png";